import GroupedSwiper, { Navigation } from 'swiper/core';

// Utility functions to add and remove classes
const addClasses = (items) =>
  items.forEach((item) => {
    item.classList.add('card--horizontal');
    item.classList.remove('card--slider');
  });
const removeClasses = (items) =>
  items.forEach((item) => {
    item.classList.remove('card--horizontal');
    item.classList.add('card--slider');
  });

// Function to build up the markup
const buildMarkup = (items) => {
  const built = items.map((innerItems) => {
    // Create a new wrapper
    const wrapperDiv = document.createElement('div');
    wrapperDiv.classList.add('swiper-slide');
    wrapperDiv.classList.add(`swiper-slide--${innerItems.length}`);

    // add 1 or 2 items to it
    innerItems.forEach((item) => wrapperDiv.appendChild(item));

    // Return the new element
    return wrapperDiv;
  });

  return built;
};

const buildSlider = (cards, wrapper) => {
  // 1. Get the size
  const { innerWidth } = window;

  // 3. Convert to array
  const cardArray = [...Array.from(cards)];

  // 4. Holder for new grouped cards
  const newCards = [];

  // 5. Loop the slides to chuck them up
  let odd = true;
  let i = 0;
  while (cardArray.length >= 1) {
    const secondValue = innerWidth <= 992 || cards.length <= 2 ? 1 : 2;
    // 1 or 2 lumps sir?
    const take = odd ? 1 : secondValue;

    const chuck = cardArray.splice(0, take);

    if (take === 1) {
      removeClasses(chuck);
    } else {
      addClasses(chuck);
    }

    newCards.push(chuck);
    i++;
    odd = !odd;
  }

  // Build the new markup based on the groupings
  //
  const newMarkUp = buildMarkup(newCards);

  // replace in the DOM
  const dev = newMarkUp.map((item) => item.outerHTML).join('');

  wrapper.innerHTML = dev;
};

var groupPlugin = {
  name: 'group',
  params: {
    debugger: false,
  },
  on: {
    init: function (swiper) {
      if (!swiper.params.debugger) return;
      const { innerWidth } = window;
    },
    resize: function (swiper) {
      // runs for all so lets be safe

      if (!swiper.wrapperEl.classList.contains('card-slider-grouped__items')) {
        return;
      }
      const cards = swiper.wrapperEl.querySelectorAll('.card');
      buildSlider(cards, swiper.wrapperEl);
      swiper.update();
      if (!swiper.params.debugger) return;
    },
  },
};

const initSlider = (slider, wrapper) => {
  const cards = slider.querySelectorAll('.card');

  const styles = getComputedStyle(document.documentElement);
  const spaceBetween = parseInt(styles.getPropertyValue('--spaceSmall'), 10);
  buildSlider(cards, wrapper);
  const groupedSlider: any = new GroupedSwiper(slider, {
    watchOverflow: true,
    init: false,
    slidesPerView: 1.2,
    spaceBetween,
    preventClicksPropagation: false,
    noSwiping: true,
    noSwipingClass: 'nav-links',
    navigation: {
      nextEl: '.card-slider-grouped__next',
      prevEl: '.card-slider-grouped__prev',
    },

    breakpoints: {
      768: {
        slidesPerView: 2.1,
        autoHeight: true,
      },
      1200: {
        slidesPerView: 2.05,
        autoHeight: true,
      },
    },
  });

  groupedSlider.init();

  return groupedSlider;
};

(function () {
  GroupedSwiper.use([Navigation, groupPlugin]);

  const sliders: NodeListOf<HTMLElement> = document.querySelectorAll<HTMLElement>('.card-slider-grouped');

  const ACTIVE_CLASS = 'nav-links__item--active';

  sliders.forEach((slider) => {
    let currentSelected = 'all';
    const wrapper = slider.querySelector('.swiper-wrapper');
    const orgWrapper: any = wrapper.cloneNode(true);

    const jsSlider = initSlider(slider, wrapper);

    // Check for nav

    const nav = slider.querySelector('.nav-links__items');
    const navLinks = nav.querySelectorAll('a');
    const navList = nav.querySelectorAll('li');

    if (!nav) {
      return;
    }

    navLinks.forEach((item) => {
      item.addEventListener('click', (evt: any) => {
        evt.preventDefault();
        evt.stopPropagation();
        evt.stopImmediatePropagation();

        const filter = evt.currentTarget.parentNode.getAttribute('data-filter').trim();

        if (!filter || filter === currentSelected) {
          return;
        }
        currentSelected = filter;

        navList.forEach((li) => li.classList.remove(ACTIVE_CLASS));

        evt.currentTarget.parentNode.classList.add(ACTIVE_CLASS);

        if (filter === 'all') {
          wrapper.innerHTML = orgWrapper.cloneNode(true).innerHTML;
          jsSlider.destroy();
          initSlider(slider, wrapper);
          return;
        }

        const allCards = orgWrapper.cloneNode(true).querySelectorAll('.swiper-slide');

        const newCards: any[] = Array.from(allCards).filter(
          (c: HTMLElement) => c.getAttribute('data-filter') === filter
        );

        wrapper.innerHTML = '';
        newCards.forEach((card) => wrapper.appendChild(card));
        jsSlider.destroy();
        initSlider(slider, wrapper);
      });
    });
  });
})();
